import React  from "react";
import { useParams } from 'react-router-dom';
import Card from "components/card";

const ViewTrainingModuleRequest = () => {
	const { recordId } = useParams();
    
	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<Card extra={"w-full h-full p-4"}>
					TBD
				</Card>
	      </div>
	    </div>
    );
};

export default ViewTrainingModuleRequest;